import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import tender_inside from "./tender_inside.vue";

window.tenderInsidepp = createApp({
    name : "tenderInsidepp",
    id : "tenderInsidepp",
    components : {
        tender_inside : tender_inside,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

tenderInsidepp.mount('#tender_inside');